import { useCtrlShiftK } from '@hooks/useCtrlShiftK';
import { useMemo, useState } from 'react';

import type { EnvironmentService } from './application/EnvironmentService/EnvironmentService';
import { FakeAnalyticsService } from './infrastructure/FakeAnalyticsService';
import type { LoggingService } from '@application/LoggingService';

export const useFakeAnalyticsService = ({
  environmentService,
  loggingService,
}: {
  environmentService: EnvironmentService;
  loggingService: LoggingService;
}) => {
  const analyticsInConsole =
    environmentService.getPossiblyUndefined('PUBLIC_ANALYTICS_IN_CONSOLE') ===
    'true';

  const fakeAnalyticsService = useMemo(
    () => new FakeAnalyticsService(loggingService),
    [loggingService],
  );

  const [analyticsService, setAnalyticsService] =
    useState<FakeAnalyticsService | null>(
      analyticsInConsole ? fakeAnalyticsService : null,
    );

  useCtrlShiftK(() => {
    setAnalyticsService(
      analyticsService === null ? fakeAnalyticsService : null,
    );
  });

  return analyticsService;
};
